import React from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';

const AIModeModal = ({ 
    isOpen, 
    onClose, 
    onConfirm,
    isTurningOff = true
}) => {
    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm();
        }
        onClose();
    };

    const handleCancel = () => {
        onClose();
    };

    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-[99999]" onClose={handleCancel}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm z-[99999]" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto z-[99999]">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full max-w-[400px] mx-auto transform overflow-hidden rounded-lg bg-black border border-[rgba(255,255,255,0.1)] p-6 text-left align-middle shadow-xl transition-all z-[99999]">
                                
                                {/* Header */}
                                <div className="flex items-center justify-between mb-6">
                                    <Dialog.Title as="h2" className="text-white text-[14px] font-medium">
                                        {isTurningOff ? 'Turn Off AI Mode?' : 'Turn On AI Mode?'}
                                    </Dialog.Title>
                                    <span
                                        onClick={handleCancel}
                                        className="text-white text-[12px] font-normal cursor-pointer hover:opacity-70"
                                    >
                                        Close
                                    </span>
                                </div>

                                {/* Message */}
                                <div className="mb-6">
                                    {isTurningOff ? (
                                        <>
                                            <p className="text-[rgba(255,255,255,0.7)] text-[12px] leading-[1.4] text-left mb-3">
                                                When AI mode is turned off:
                                            </p>
                                            <ul className="text-[rgba(255,255,255,0.7)] text-[12px] leading-[1.6] text-left list-disc list-inside space-y-2 mb-3">
                                                <li>You can still use form prompts (Add upcoming release, New task, Pending shows, etc.)</li>
                                                <li>Chat with AI will be disabled</li>
                                                <li>Only preset prompts will be available</li>
                                                <li>Your data will not be cross-referenced by our AI</li>
                                            </ul>
                                            <p className="text-[rgba(255,255,255,0.7)] text-[12px] leading-[1.4] text-left">
                                                You can turn AI mode back on at any time from the sidebar.
                                            </p>
                                        </>
                                    ) : (
                                        <p className="text-[rgba(255,255,255,0.7)] text-[12px] leading-[1.4] text-left">
                                            Turning AI mode back on will enable full chat functionality and allow AI to cross-reference your data to provide better assistance.
                                        </p>
                                    )}
                                </div>

                                {/* Action Buttons */}
                                <div className="flex justify-end space-x-2 pt-4">
                                    <button
                                        type="button"
                                        className="bg-[#121212] hover:bg-[#1a1a1a] text-white text-[12px] font-medium py-2 px-4 rounded-[8px] transition-colors focus:outline-none"
                                        onClick={handleCancel}
                                    >
                                        Cancel
                                    </button>
                                    
                                    <button
                                        type="button"
                                        className="bg-[#FF3B30] hover:bg-[#e63329] text-white text-[12px] font-medium py-2 px-4 rounded-[8px] transition-all focus:outline-none"
                                        onClick={handleConfirm}
                                    >
                                        {isTurningOff ? 'Turn Off AI' : 'Turn On AI'}
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
};

export default AIModeModal;

